import { render, staticRenderFns } from "./string-filter.vue?vue&type=template&id=4168c9a0"
import script from "./string-filter.vue?vue&type=script&lang=js"
export * from "./string-filter.vue?vue&type=script&lang=js"
import style0 from "./string-filter.vue?vue&type=style&index=0&id=4168c9a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./string-filter.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports